module.exports = __webpack_public_path__ + "static/whitehat-604095815fc1ff39371a46bec50b09e7.jpeg";